import { createAction } from "redux-actions";
import { consumirServicioEncirptacion } from "../../api";
import { urlLoginMex } from "../../constants/urls";

export const LOGIN_HAS_ERRORED = "LOGIN_HAS_ERRORED";
export const LOGIN_IS_LOADING = "LOGIN_IS_LOADING";
export const CAMBIAR_CONTRASENIA_HAS_ERRORED = "CAMBIAR_CONTRASENIA_HAS_ERRORED";
export const CAMBIAR_CONTRASENIA_IS_LOADING = "CAMBIAR_CONTRASENIA_IS_LOADING";

export const SOLICITAR_CONTRASENIA_HAS_ERRORED = "SOLICITAR_CONTRASENIA_HAS_ERRORED";
export const SOLICITAR_CONTRASENIA_IS_LOADING = "SOLICITAR_CONTRASENIA_IS_LOADING";

export const VERIFICAR_TOKEN_HAS_ERRORED = "VERIFICAR_TOKEN_HAS_ERRORED";
export const VERIFICAR_TOKEN_IS_LOADING = "VERIFICAR_TOKEN_IS_LOADING";
export const RECUPERAR_CONTRASENIA_OK = "RECUPERAR_CONTRASENIA_OK";

export const USER_IS_LOGGED_IN = "USER_IS_LOGGED_IN";
export const CAMBIAR_CONTRASENIA_OK = "CAMBIAR_CONTRASENIA_OK";
export const SET_MSG_ERROR_CAMBIO_CONTRASENA = "SET_MSG_ERROR_CAMBIO_CONTRASENA";
export const SET_DATA_USUARIO = "SET_DATA_USUARIO";
export const SET_DATA_USUARIO_SUSCRIPTOR = "SET_DATA_USUARIO_SUSCRIPTOR";

export const ENVIAR_CORREO = "ENVIAR_CORREO";
export const LIMPIAR_LOGIN = "LIMPIAR_LOGIN";
export const LOGOUT_SUSCRIPTOR = "LOGOUT_SUSCRIPTOR";
export const LIMPIAR_CAMBIAR_CONTRASENIA = "LIMPIAR_CAMBIAR_CONTRASENIA";
export const LIMPIAR_SOLICITAR_CONTRASENIA = "LIMPIAR_SOLICITAR_CONTRASENIA";
export const LIMPIAR_TOKEN = "LIMPIAR_TOKEN";
export const SET_COUNT_CARRITO = "SET_COUNT_CARRITO";
export const SET_DATA_LEEDS = "SET_DATA_LEEDS";

export const LISTA_COMPRAS_HAS_ERRORED = "LISTA_COMPRAS_HAS_ERRORED";
export const SET_DATA_LISTA_COMPRAS = "SET_DATA_LISTA_COMPRAS";
export const LISTA_COMPRAS_LOADING = "LISTA_COMPRAS_LOADING";
export const LIMPIAR_DATOS_LISTA_COMPRAS = "LIMPIAR_DATOS_LISTA_COMPRAS";

const loginError = createAction(LOGIN_HAS_ERRORED);
const loginIsLoading = createAction(LOGIN_IS_LOADING);

export const limpiarCambioContrasenia = createAction(LIMPIAR_CAMBIAR_CONTRASENIA);

export const limpiarVerificarToken = createAction(LIMPIAR_TOKEN);

export const limpiarSolicitarContrasenia = createAction(LIMPIAR_SOLICITAR_CONTRASENIA);

export const limpiarLogin = createAction(LIMPIAR_LOGIN);
export const setContraseniaOK = createAction(CAMBIAR_CONTRASENIA_OK);
export const setMsgCambiarContrasena = createAction(SET_MSG_ERROR_CAMBIO_CONTRASENA);
export const recuperarContraseniaOK = createAction(RECUPERAR_CONTRASENIA_OK);
export const enviarCorreo = createAction(ENVIAR_CORREO);

export const dataUsuario = createAction(SET_DATA_USUARIO);
export const setDataLeeds = createAction(SET_DATA_LEEDS);
export const listaComprasHasErrored = createAction(LISTA_COMPRAS_HAS_ERRORED);
export const listaComprasIsLoading = createAction(LISTA_COMPRAS_LOADING);
export const setListaCompras = createAction(SET_DATA_LISTA_COMPRAS);
export const limpiarListaCompras = createAction(LIMPIAR_DATOS_LISTA_COMPRAS);

export const loginAsSuscriptor = (user) => {
  return {
    type: SET_DATA_USUARIO_SUSCRIPTOR,
    payload: { ...user },
  };
};

export const logoutAsSuscriptor = (user) => {
  return {
    type: LOGOUT_SUSCRIPTOR,
    payload: { ...user },
  };
};

export function userIsLoggedIn(bool) {
  return {
    type: USER_IS_LOGGED_IN,
    userIsLoggedIn: bool,
  };
}
export function countCarrito(val) {
  return {
    type: SET_COUNT_CARRITO,
    countCarrito: val,
  };
}

const DATA_USUARIO = {
  correo: "",
  cedula: "",
  nombres: "",
  apellidos: "",
  sucursal: "",
  sucursalCodCore: "",
  errorDescripcion: "",
  userIsLoggedIn: false,
  cliCodigoCore: "",
  disclaimerVer: false,
  disclaimerFecha: "",
  disclaimerUrl: "",
};

export const loginFetchMex = (body) => async (dispatch) => {
  dispatch(loginIsLoading());

  const onError = (errorDescripcion = "Error general") => {
    const dataUsuario1 = {
      ...DATA_USUARIO,
      errorDescripcion,
      userIsLoggedIn: false,
    };
    dispatch(dataUsuario(dataUsuario1));
    dispatch(loginError());
  };

  try {
    const data = await consumirServicioEncirptacion(urlLoginMex, body);
    if (data.transaccion) {
      let nombres1 = data.cliNombre1 + " " + data.cliNombre2;
      let apellidos1 = data.cliApellido1 + " " + data.cliApellido2;

      if (!data.cliNombre2) nombres1 = data.cliNombre1;

      if (!data.cliApellido2) apellidos1 = data.cliApellido1;

      const dataUsuario2 = {
        ...DATA_USUARIO,
        correo: data.cliEmail,
        cedula: data.cliIdentificacion,
        nombres: nombres1,
        apellidos: apellidos1,
        sucursal: data.cliSucursal,
        sucursalCodCore: data.sucCodigoCore,
        errorDescripcion: data.errorDescripcion,
        userIsLoggedIn: true,
        cliCodigoCore: data.cliCodigoCore,
        // disclaimerVer: data.disclaimerVer,
        // disclaimerFecha: disFechaAux,
        // disclaimerUrl: data.disclaimerUrl,
        usu_tipo_usuario: data.cliTipo,
        brokerRUC: data?.brokerRUC || "",
        brokerNombre: data?.brokerNombre || "",
        brokerCodigo: data?.brokerCodigo || "",
        fechaUltimoAcceso: data?.fechaUltimoAcceso,
        nombreAgente: data.nombreAgente,
        codigoAgente: data.codigoAgente,
        cambiarContrasenia: data?.cambiarContrasenia || false,
        agente: data?.agente,
      };
      if (data.cliTipo === "usu-suscriptor-sbs") {
        dataUsuario2.idSuscriptor = data.cliCodigoCore;
        dataUsuario2.isSuscriptor = true;
      }
      //Poner como array 
      if (data.cliTipo === "usu-suscriptor-casualty-contratistas") {
        dataUsuario2.idSuscriptor = data.cliCodigoCore;
        dataUsuario2.isSuscriptor = true;
      }
      dispatch(dataUsuario(dataUsuario2));
    } else {
      onError(data.errorDescripcion);
    }
  } catch (error) {
    onError();
  }
};
